<!--<div>{{config.title}}</div>-->
<div id="gauge-{{chartId}}" [ngClass]="chartClass"></div>
